export function init() {
  GDTurnstile.isLoaded = isTurnstileLoaded();

  if (GDTurnstile.isLoaded) {
    renderStaticTurnstile();
  }
}

export function loadTurnstile(
  turnstileContainer,
  callback,
  action = 'donate',
  autoRemove = true,
) {
  let turnstileID;

  const turnstileCallback = (token) => {
    callback(token, turnstileID);
    turnstileContainer.style.display = 'none';
    if (autoRemove) {
      removeTurnstile(turnstileID);
    }
  };

  const beforeInteractiveCallback = () => {
    if (
      window.navigator?.userAgent &&
      window.navigator.userAgent.startsWith('playwright-')
    ) {
      turnstileCallback('');
    } else {
      turnstileContainer.scrollIntoView({
        behavior:'smooth',
        block:'center'
      });
      turnstileContainer.focus();
    }
  };

  const renderTurnstile = () => {
    const gdt = new GDTurnstile(turnstileContainer, {
      action: action,
      callback: turnstileCallback,
      'before-interactive-callback': beforeInteractiveCallback,
    });

    turnstileID = gdt.render();
  };

  if (GDTurnstile.isLoaded) {
    renderTurnstile();
  } else {
    embedTurnstile(renderTurnstile);
  }
}

export function removeTurnstile(turnstileID) {
  try {
    turnstile.remove(turnstileID);
  } catch (err) {
    console.log('no turnstile to remove', err);
  }
}

function renderStaticTurnstile() {
  document
    .querySelectorAll('.' + guidedogs_turnstile.containerClass)
    .forEach((item) => {
      setInteractivity(item, false);

      const gdt = new GDTurnstile(item, {
        action: item.dataset.action || null,
        'before-interactive-callback': () => {
          setInteractivity(item, true);
        },
      });

      gdt.render();
    });
}

function setInteractivity(el, isInteractive) {
  el.setAttribute('aria-hidden', !isInteractive);
  el.toggleAttribute('inert', !isInteractive);
}

function isTurnstileLoaded() {
  return (
    document.querySelector('script#turnstile-js') !== null &&
    typeof turnstile !== 'undefined'
  );
}

function embedTurnstile(callback) {
  GDTurnstile.isLoaded = true;
  const script = document.createElement('script');
  script.onload = callback;
  script.src =
    'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

  document.head.appendChild(script);
}

class GDTurnstile {
  static isLoaded = false;
  constructor(container, renderArgs = {}) {
    this.container = container;
    this.renderArgs = renderArgs;
    this.widgetID = null;
    this.isCF7 = this.renderArgs.action && this.renderArgs.action === 'cf7';
    this.isShop =
      this.renderArgs.action && this.renderArgs.action === 'shop-pay';
  }

  render() {
    this.container.style.display = '';
    this.widgetID = turnstile.render(this.container, {
      sitekey: guidedogs_turnstile.sitekey,
      appearance: 'interaction-only',
      'response-field-name': guidedogs_turnstile.fieldname,
      theme: 'light',
      ...this.renderArgs,
    });

    this.registerCF7Events();
    this.registerShopEvents();

    return this.widgetID;
  }

  registerShopEvents() {
    if (!this.isShop) {
      return;
    }

    $(document.body).on('checkout_error', () => {
      try {
        turnstile.reset(this.widgetID);
      } catch (e) {
        console.log(e);
      }
    });
  }

  registerCF7Events() {
    if (!this.isCF7) {
      return;
    }

    ['wpcf7submit'].forEach((e) => {
      document.addEventListener(e, () => {
        try {
          turnstile.reset(this.widgetID);
        } catch (e) {
          console.log(e);
        }
      });
    });
  }
}
